export default "__VITE_ASSET__BRqSHX9G__"